import PureLink, { PureLinkVariant } from '../../../common/Link/PureLink';
import styles from './Article.module.scss';
import { LABEL_KEYS } from '../../../../lib/constants/labelKeys';
import PureImage from '../../../common/Image/PureImage';
import shortenText from '../../../../lib/utils/shortenText';
import { ARTICLE_PARAMS } from '../../../../lib/constants/courses';
import { Label } from '../../../common/Label/Label';
import { useAttributeLabel } from '../../../../lib/hooks/labels';
import { ATTRIBUTES } from '../../../../lib/constants/attributes';
import { articleListTestIds } from '../../../../lib/tests/testIds';
import { Article } from '../../../common/model';
import { CY_ARTICLE_ATTRIBUTES } from '../../../../lib/constants/cypress';
import { SCALE } from '../../../common/Image/ImageScale';
import { isNil } from '../../../../lib/utils/isNil';

const ArticleComponent = ({ heading, content, asset, link, articleType }: Article): JSX.Element => {
  const label = useAttributeLabel(ATTRIBUTES.TITLE, LABEL_KEYS.ARTICLE_LINK_LABEL);

  return (
    <article className={styles.articleContainer}>
      <PureImage src={asset?.path ?? ''} className={styles.imageAspectRatio} scale={SCALE.GRID} />
      <span className={styles.articleType} data-cy={CY_ARTICLE_ATTRIBUTES.LABEL}>
        {articleType}
      </span>
      <h3 className={styles.articleTitle}>{shortenText(heading, { length: ARTICLE_PARAMS.TITLE_LIMIT })}</h3>
      <p data-testid={articleListTestIds.description}>
        {shortenText(content, { length: ARTICLE_PARAMS.DESCRIPTION_LIMIT })}
      </p>
      {!isNil(link) ? (
        <PureLink href={link} {...label} className={styles.articleCta} variant={PureLinkVariant.Link}>
          <Label name={LABEL_KEYS.ARTICLE_LINK_LABEL} />
        </PureLink>
      ) : null}
    </article>
  );
};

export default ArticleComponent;
